import EconomicCalendarPage from '@/modules/economic-calendar/economic-calendar-page';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/economic-calendar/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <EconomicCalendarPage />;
}
